const CANONICAL_APP_ORIGIN = "https://todaysbrief.app";
const ALLOWED_AUTH_EXIT_PATHS = new Set([
  "/auth/forgot",
  "/auth/sign-in",
]);

function parsedOrigin(value) {
  try {
    return new URL(String(value || "")).origin;
  } catch {
    return null;
  }
}

export function isDedicatedPasswordResetOrigin(currentOrigin) {
  const origin = parsedOrigin(currentOrigin);
  if (!origin) return false;
  const url = new URL(origin);
  const canonical = new URL(CANONICAL_APP_ORIGIN);
  return (
    url.protocol === "https:" &&
    url.hostname.startsWith("reset.") &&
    url.hostname.endsWith(`.${canonical.hostname}`)
  );
}

/**
 * Drain-only support for links issued by the retired dedicated reset
 * template. That host has intentionally narrow CSRF authority, so any action
 * that starts a new auth flow must leave it and return to the canonical app.
 * New shared-template reset links, local development, and the canonical host
 * stay relative.
 */
export function passwordResetAuthExitDestination(path, currentOrigin) {
  if (!ALLOWED_AUTH_EXIT_PATHS.has(path)) {
    throw new TypeError("unsupported_password_reset_auth_exit");
  }
  const origin = parsedOrigin(currentOrigin);
  if (!origin) return path;
  const url = new URL(origin);
  const canonicalHostname = isDedicatedPasswordResetOrigin(origin)
    ? url.hostname.slice("reset.".length)
    : null;
  return canonicalHostname
    ? `https://${canonicalHostname}${path}`
    : path;
}

export function isCrossOriginAuthExit(destination, currentOrigin) {
  const destinationOrigin = parsedOrigin(destination);
  const origin = parsedOrigin(currentOrigin);
  return Boolean(destinationOrigin && origin && destinationOrigin !== origin);
}

export { CANONICAL_APP_ORIGIN };
